export const theme = {
  colors: {
    primary: '#7c3aed',
    primaryLight: '#a78bfa',
    primaryDark: '#5b21b6',
    secondary: '#ec4899',
    background: '#0f0f23',
    surface: '#1a1a35',
    surfaceHover: '#242445',
    border: '#2d2d5e',
    text: '#e2e8f0',
    textSecondary: '#94a3b8',
    success: '#10b981',
    error: '#ef4444',
    warning: '#f59e0b',
    pending: '#f59e0b',
    approved: '#10b981',
    rejected: '#ef4444',
  },
  borderRadius: '12px',
  shadow: '0 4px 24px rgba(0,0,0,0.4)',
};

export type Theme = typeof theme;
